'use es6';

import { wrapReduxAction } from '../lib/ActionWrapper';
import { getAdsUserAttributes, setOnboardingTourStatusForUser, setCouponBannerHiddenForUser, setSeenCouponBadgeForUser, setSeenEducationColumnsForUser, setSeenMarketingContactsToggleForUser, setSeenMarketingContactsCheckboxForUser, setUserAttribute } from '../data/UserAttributesData';
export const fetchAdsUserAttributes = userId => dispatch => wrapReduxAction(getAdsUserAttributes.bind(null, userId), 'USER_ATTRIBUTES_FETCH', {
  dispatch,
  transform: response => response.attributes
});
export const saveOnboardingTourStatusForUser = userId => dispatch => wrapReduxAction(setOnboardingTourStatusForUser.bind(null, userId), 'USER_ATTRIBUTES_SYNC', {
  dispatch
});
export const saveCouponBannerHiddenForUser = userId => dispatch => wrapReduxAction(setCouponBannerHiddenForUser.bind(null, userId), 'USER_ATTRIBUTES_SYNC', {
  dispatch
});
export const saveSeenCouponBadgeForUser = userId => dispatch => wrapReduxAction(setSeenCouponBadgeForUser.bind(null, userId), 'USER_ATTRIBUTES_SYNC', {
  dispatch
});
export const saveSeenEducationColumnsForUser = (userId, columns) => dispatch => wrapReduxAction(setSeenEducationColumnsForUser.bind(null, userId, columns), 'USER_ATTRIBUTES_SYNC', {
  dispatch
});
export const saveSeenMarketingContactsToggleForUser = userId => dispatch => wrapReduxAction(setSeenMarketingContactsToggleForUser.bind(null, userId), 'USER_ATTRIBUTES_SYNC', {
  dispatch
});
export const saveSeenMarketingContactsCheckboxForUser = userId => dispatch => wrapReduxAction(setSeenMarketingContactsCheckboxForUser.bind(null, userId), 'USER_ATTRIBUTES_SYNC', {
  dispatch
});
/**
 * Save a new value for the given user attribute.
 */

export const saveUserAttribute = (attribute, userId, value) => dispatch => wrapReduxAction(setUserAttribute.bind(null, attribute, userId, value), 'USER_ATTRIBUTES_SYNC', {
  dispatch
});